// tierLimits.js — per-tier capability limits. Single source of truth for what each
// tier may do. profiles.tier is hand-set for now (founder sets it); Stripe wiring is
// Phase 7/8. 3.3 will read these to enforce caps when migrating follow-state to
// Supabase; this phase only defines them. Caps from the 2026-06-10 tier-lock:
// Scout 5+5 / Trader 20+20 / Edge uncapped (Infinity). Timeframes from the product-vision PDF.
export const DEFAULT_TIER = "scout";

export const TIER_LIMITS = {
  scout:  { label: "Scout",  crypto: 5,  stock: 5,  timeframes: ["1h", "4h"],                    allowedModes: ["Conservative", "Moderate"] },
  trader: { label: "Trader", crypto: 20, stock: 20, timeframes: ["15m", "1h", "4h", "6h"],       allowedModes: ["Conservative", "Moderate", "Aggressive"] },
  edge:   { label: "Edge",   crypto: Infinity, stock: Infinity, timeframes: ["15m", "1h", "4h", "6h", "1d"], allowedModes: ["Conservative", "Moderate", "Aggressive"] },
};

export function limitsForTier(tier) {
  return TIER_LIMITS[tier] ?? TIER_LIMITS[DEFAULT_TIER];
}
